export default __webpack_public_path__ + "static/media/droplove_light_logo.0f22cb28.png";